export const privacyPolicyData = [
  {
    section: "Introduction",
    items: [
      {
        q: "Overview",
        a: `This Privacy Policy describes how [Your Company Name] ("we", "us", or "our") collects, uses, discloses, and protects the personal data of individuals who interact with our global staffing and recruitment services.`,
      },
      {
        q: "Global Operations",
        a: `We are registered in India and operate internationally through verified Employer-of-Record (EOR) and local service partners to ensure compliance with local labour and data protection laws.`,
      },
    ],
  },
  {
    section: "Who This Policy Applies To",
    items: [
      { q: "Candidates", a: "Individuals submitting information to us for job opportunities." },
      { q: "Clients", a: "Organizations engaging our staffing and workforce services." },
      { q: "Visitors", a: "Users accessing our website or digital platforms." },
    ],
  },
  {
    section: "What Personal Data We Collect",
    items: [
      {
        q: "For Candidates",
        a: `We collect contact details, resumes, employment history, LinkedIn profiles, reference data, interview notes, and sensitive data (if legally required and with consent).`,
      },
      {
        q: "For Clients",
        a: `We collect company details, contact names, communication records, and staffing requirements to deliver our services.`,
      },
    ],
  },
  {
    section: "How We Collect Data",
    items: [
      { q: "Directly from You", a: "Via web forms, LinkedIn, email, or phone communication." },
      { q: "Third-Party Sources", a: "Through job boards, referrals, or professional networks." },
      { q: "Public Information", a: "From public profiles and professional platforms." },
    ],
  },
  {
    section: "How We Use Personal Data",
    items: [
      { q: "For Candidates", a: "To match your profile with suitable job openings and manage recruitment processes." },
      { q: "For Clients", a: "To provide staffing solutions, communicate, and manage contracts." },
      { q: "For Website Visitors", a: "To improve website performance and respond to contact inquiries." },
    ],
  },
  {
    section: "Data Sharing",
    items: [
      { q: "Service Providers", a: "We use vendors (cloud storage, applicant tracking, EOR partners) under confidentiality agreements." },
      { q: "Legal Obligations", a: "Information may be disclosed where required by law." },
      { q: "Business Transfers", a: "In case of mergers, acquisitions, or restructuring." },
    ],
  },
  {
    section: "Data Retention",
    items: [
      { q: "Candidates", a: "Retained for up to two years unless you request earlier deletion." },
      { q: "Clients", a: "Retained for the duration of the relationship and legal requirements." },
    ],
  },
  {
    section: "Data Security",
    items: [
      { q: "Security Practices", a: "We use encryption, access controls, and regular security audits to safeguard data." },
      { q: "Employee Training", a: "All staff receive periodic training on data privacy and protection." },
    ],
  },
  {
    section: "Your Rights",
    items: [
      { q: "Access and Correction", a: "Request access to or correction of your data." },
      { q: "Deletion and Objection", a: "Request deletion or object to certain processing." },
      { q: "Withdraw Consent", a: "Withdraw consent for processing at any time." },
    ],
  },
  {
    section: "International Data Transfers",
    items: [
      {
        q: "Data Transfers",
        a: `We may transfer data outside your country to partners and service providers under appropriate safeguards such as Standard Contractual Clauses (SCCs).`,
      },
    ],
  },
  {
    section: "Cookies & Analytics",
    items: [
      {
        q: "Website Usage",
        a: `We use cookies and analytics tools to enhance website functionality and performance.`,
      },
    ],
  },
  {
    section: "Legal Frameworks",
    items: [
      { q: "India", a: "We comply with India’s Digital Personal Data Protection Act (DPDP Act, 2023)." },
    ],
  },
  {
    section: "Contact Information",
    items: [
      { q: "Email", a: "info@mapeach.com" },
    ],
  },
];
